import objectFitImages from 'object-fit-images';
import StateManager from '../../global/js/lib/jquery.state-manager';
import '../../global/js/lib/jquery.plugin-base';

//Define breakpoints globally

(function ($, window) {
  window.StateManager.init([
    {
      state: 'xxs',
      enter: 0,
      exit: 374,
    },
    {
      state: 'xs',
      enter: 375,
      exit: 767,
    },
    {
      state: 'sm',
      enter: 768,
      exit: 1023,
    },
    {
      state: 'md',
      enter: 1024,
      exit: 1365,
    },
    {
      state: 'lg',
      enter: 1366,
      exit: 1919,
    },
    {
      state: 'xl',
      enter: 1920,
      exit: 5000,
    },
  ]);
})(jQuery, window);
//general ContentFetcher for Ajax-Requests used by multiple plugins
window.ContentFetcher = (function () {
  var requests = [];
  var requestTick = 250;
  return {
    addReq: function (request) {
      requests.push(request);
    },
    fetch: function (request, callBack) {
      var self = this;
      request.callBack = callBack;
      self.addReq(request);
      var checkForRun = function (formerRequestCount) {
        if (formerRequestCount === requests.length) {
          self.runLast();
          window.clearInterval(self.waitForExecution);
        }
      };
      self.waitForExecution = window.setInterval(checkForRun, requestTick, requests.length);
    },
    removeReq: function (request) {
      if ($.inArray(request, requests) > -1) requests.splice($.inArray(request, requests), 1);
    },
    run: function () {
      var self = this;
      var nextReq = requests.shift();
      if (nextReq) {
        var callBack = nextReq.callBack;
        $.ajax(nextReq)
          .done(callBack)
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.error(textStatus);
            console.error(errorThrown);
          })
          .always(function () {
            self.tid = window.setTimeout(function () {
              self.run.apply(self, []);
            });
          });
      } else {
        window.clearTimeout(self.tid);
      }
    },
    runLast: function () {
      var self = this;
      requests = [requests.pop()];
      self.run.apply(self, []);
    },
    stop: function () {
      requests = [];
      clearTimeout(this.tid);
    },
  };
})();

export function validateForm($form) {
  const $requiredFields = $form.find('[required]');
  for (let i = 0; i < $requiredFields.length; i++) {
    const $input = $requiredFields.eq(i);
    const $label = $("label[for='" + $input.attr('id') + "']");
    $(".form-error-message").remove();
    if (!$input.val()) {
      const $inputContainer = $input.parent();
      $label.css('color', 'red');
      $input.css('border', 'thin solid red');
      $inputContainer.before("<div class='form-error-message'>Bitte Pflichtfeld ausfüllen</div>");
      return false;
    } else {
      $input.css('border', '');
      $label.css('color', '');
    }
  }
  return true;
}

/* main functionality wait for jquery ready */
$('html').removeClass('no-js').addClass('js');
/********************************************************************/
/* Breakpoints  ||  As in Stylesheets                               */
/* iPad Pro Landscape = 1366px - 1920px                             */
/* iPad Landscape & iPad Pro Portrait Ansicht = 1024px - 1366px     */
/* iPad Portrait Ansicht = 768px - 1024px                           */
/* Mobile = 375px - 768px                                           */
/********************************************************************/
window.ImageVersions = {
  mobile: {
    min_width: 0,
    max_width: 768,
    width: 50,
    height: 400,
  },
  tablet: {
    min_width: 768,
    max_width: 1024,
    width:  150,
    height:  600,
  },
  desktop: {
    min_width: 1024,
    width: 960,
    height: 700,
  }
};
window.Testing = 'blabla';
$(document).ready(function () {
  /*reload between desktop and mobile*/
  window.StateManager.registerListener([
    {
      state: '*',
      exit: function () {
        $.publish('global/switchBreakpoint');
      },
    },
  ]);
  objectFitImages();
});
